import { render, staticRenderFns } from "./dealer-content.vue?vue&type=template&id=15cf1adf&"
import script from "./dealer-content.vue?vue&type=script&lang=js&"
export * from "./dealer-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports